/** The generic catch-all purpose is always listed last, after the specific ones. */
export const CATCH_ALL_PURPOSE = "Other";
